<template>
  <div class="md-12">
    <b-card no-body>
      <b-tabs v-model="tabIndex" card lazy>
        <b-tab title="Abelha" :title-link-class="linkClass(0)" v-if="hasPermission('list_bi_abelha')">
          <b-row>
            <b-embed type="iframe" aspect="16by9"
              src="https://app.powerbi.com/view?r=eyJrIjoiNThjYzA0NTgtMGFkYi00ZDYyLTk2YWQtNzYwNDI2YWZiMjY1IiwidCI6IjA2N2Y1YTJjLWM2ZTQtNGY0Zi1hMThhLTk1ZmJmYjJkODNlMiJ9"
              allowfullscreen>
            </b-embed>
          </b-row>
        </b-tab>
        <b-tab title="Lojas Personalizadas" :title-link-class="linkClass(1)" v-if="hasPermission('list_bi_lojas_personalizadas')">
          <b-row>
            <b-embed type="iframe" aspect="16by9"
              src="https://app.powerbi.com/view?r=eyJrIjoiNDJkYzE0NzEtMTQ0ZS00NDAxLWIzZDAtZmYyMTJiYzBjMGJhIiwidCI6IjA2N2Y1YTJjLWM2ZTQtNGY0Zi1hMThhLTk1ZmJmYjJkODNlMiJ9"
              allowfullscreen>
            </b-embed>
          </b-row>
        </b-tab>
        <b-tab title="Farma" :title-link-class="linkClass(2)" v-if="hasPermission('list_bi_farma')">
          <b-row>
            <b-embed type="iframe" aspect="16by9"
              src="https://app.powerbi.com/reportEmbed?reportId=be804adb-501f-463a-9664-45419f82b035&autoAuth=true&ctid=067f5a2c-c6e4-4f4f-a18a-95fbfb2d83e2"
              allowfullscreen>
            </b-embed>
          </b-row>
        </b-tab>
        <b-tab title="Ocorrências" :title-link-class="linkClass(3)" v-if="hasPermission('list_bi_ocorrencia')">
          <b-row>
            <b-embed type="iframe" aspect="16by9"
              src="https://app.powerbi.com/view?r=eyJrIjoiY2U3MDRmZGEtY2NlYi00NzcxLWIyOTctMTUwN2ViMTU2MTNlIiwidCI6IjA2N2Y1YTJjLWM2ZTQtNGY0Zi1hMThhLTk1ZmJmYjJkODNlMiJ9"
              allowfullscreen>
            </b-embed>
          </b-row>
        </b-tab>
        <b-tab title="Prospectos" :title-link-class="linkClass(4)" v-if="hasPermission('list_bi_prospecto')">
          <b-row>
            <b-embed type="iframe" aspect="16by9"
              src="https://app.powerbi.com/view?r=eyJrIjoiMDNhZWFhNDAtZjAyYS00OTNjLWE4NDEtOGFkNzA5ZDNmNmI1IiwidCI6IjA2N2Y1YTJjLWM2ZTQtNGY0Zi1hMThhLTk1ZmJmYjJkODNlMiJ9"
              allowfullscreen>
            </b-embed>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>
<script>
export default {
  data() {
    return {      
      permissions: [],
      tabIndex: 0
    }
  },
  mounted() {
    this.getPermission();
  },
  methods: {
    hasPermission(value) {
      return this.permissions.some(el => el.name == value)
    },
    getPermission() {
      axios.get('/adm/users/getpermissions')
        .then((response) => {
          this.permissions = response.data.permissions;
        }).catch((erro) => {
          console.log('erro ao buscar permissoes', erro);
        })
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ['bg-primary', 'text-light']
      } else {
        return ['bg-light', 'text-dark']
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/adm_bi/Main.vue